
import BaseTextSection from "@/components/base/BaseTextSection.vue";
import BaseAlbumScroll from "@/components/base/BaseAlbumScroll.vue";
import PartnersForm from "@/components/partners/PartnersForm.vue";

export default {
  layout: 'artists',
  components: {
    BaseTextSection,
    BaseAlbumScroll,
    PartnersForm
  },
  methods: {
    scrollToForm() {
      const formElement = document.getElementById('form');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    downloadFile(locale) {
      const link = document.createElement('a');
      link.href = `/pdf/trebel_for_artists_${locale}.pdf`;
      link.download = `trebel_for_artists_${locale}.pdf`;
      link.click();
    }
  },
  computed: {
    dashboardImage() {
      return this.$device.isDesktop
        ? require(`assets/img/png/dashboard_${this.$i18n.locale}.png`)
        : require(`assets/img/png/dashboard_${this.$i18n.locale}_mobile.png`)
    },
    artistsImage() {
      return this.$device.isDesktop
        ? require(`assets/img/webp/artist_header_${this.$i18n.locale}.webp`)
        : require(`assets/img/png/artist_header_${this.$i18n.locale}_mobile.png`)
    },
    mapImage() {
      return this.$device.isDesktop
        ? require(`assets/img/png/map_${this.$i18n.locale}.png`)
        : require(`assets/img/png/map_${this.$i18n.locale}_mobile.png`);
    }
  }
}
